import { ParcDetailsDto, ParcDto, MaterielParcDto, FermetureExceptionnelleDto, FermetureTemporaireDto, ParcLimitropheDto, TypeDechetParcDto, TelephoneParcDto, PhotoPdaDto, TypeElementStockDto } from "src/api/models";
import { OuvertureParc } from "src/core/models/OuvertureParc";

export namespace Parcs {

  export class GetActifs {
    static readonly type = '[Parcs] Get active parcs';
  }

  export class GetDetail {
    static readonly type = '[Parcs] Get parc detail';
    constructor(public parcId: number) { }
  }

  export class GetDailyVisits {
    static readonly type = '[Parcs] Get parc daily visits infos';
    constructor(public parcId: number) { }
  }

  export class UpdateDetail {
    static readonly type = '[Parcs] Update parc detail';
    constructor(public parc: ParcDetailsDto) { }
  }

  export class UpdateTypeDechetParc {
    static readonly type = '[Parcs] Update type dechets parc';
    constructor(public parcId: number, public typeDechetsParc: TypeDechetParcDto[]) { }
  }

  export class GetTypeDechetParc {
    static readonly type = '[Parcs] Get type dechets parc with no destination';
    constructor(public parcId: number) { }
  }

  export class GetTypeEvacuationParc {
    static readonly type = '[Parcs] Get evacuation types parc with no destination';
    constructor(public parcId: number) { }
  }

  export class Desactivate {
    static readonly type = '[Parcs] Desactivate parc';
    constructor(public parc: ParcDto) { }
  }

  export class DeleteMateriel {
    static readonly type = '[Parcs] Delete materiel';
    constructor(public materiel: MaterielParcDto) { }
  }

  export class DeleteFermetureExceptionnelle {
    static readonly type = '[Parcs] Delete fermeture exceptionelle';
    constructor(public fermeture: FermetureExceptionnelleDto) { }
  }

  export class DeleteTelephone {
    static readonly type = '[Parcs] Delete telephone';
    constructor(public telephone: TelephoneParcDto) { }
  }

  export class AddFermetureTemporaire {
    static readonly type = '[Parcs] Add fermeture temporaire';
    constructor(public parcId: number, public fermeture: FermetureTemporaireDto) { }
  }

  export class DeleteFermetureTemporaire {
    static readonly type = '[Parcs] Delete fermeture temporaire';
    constructor(public fermeture: FermetureTemporaireDto) { }
  }

  export class AddParcLimitrophe {
    static readonly type = '[Parcs] Add parc limitrophe';
    constructor(public parcId: number, public parc: ParcLimitropheDto) { }
  }

  export class FetchParcsLimitrophesForConfiguration {
    static readonly type = '[Parcs] Get liste parcs limitrophe par distance';
    constructor(public parcId: number) { }
  }

  export class DeleteParcLimitrophe {
    static readonly type = '[Parcs] Delete parc limitrophe';
    constructor(public parcLimitropheId: number) { }
  }

  export class FetchHeuresOuvertureParc {
    static readonly type = '[Parcs] Get liste heures ouverture du parc';
    constructor(public parcId: number) { }
  }

  export class AddHeureOuvertureParc {
    static readonly type = '[Parcs] Create heures ouverture';
    constructor(public parcId: number, public dto: OuvertureParc) { }
  }

  export class UpdateHeureOuvertureParc {
    static readonly type = '[Parcs] Update heures ouverture';
    constructor(public parcId: number, public dto: OuvertureParc) { }
  }

  export class DeleteHeureOuvertureParc {
    static readonly type = '[Parcs] Delete heures ouverture';
    constructor(public parcId: number, public heureId: number) { }
  }

  export class ChangeAlertPublication {
    static readonly type = '[Alertes] Change alert publication';
    constructor(public alerteId: number, public isPublished: boolean) { }
  }

  export class ApplyScheduleAllParcs {
    static readonly type = '[Parcs] Apply schedule to all active parcs';
    constructor(public parcId: number) { }
  }

  export class DeletePhotoPda {
    static readonly type = '[Parcs] Delete Photo pda';
    constructor(public photoPda: PhotoPdaDto) { }
  }

  export class DesactivateTypeElementStock {
    static readonly type = '[Parcs] Desactivate type element stock';
    constructor(public typeElementStock: TypeElementStockDto) {}
  }
}
